<ng-content select="label,mat-label"></ng-content>
<div class="filter-group">
    <ng-content select="rfx-grid-filter-control,rfx-grid-filter-search-control"></ng-content>
</div>
